module.exports = angular.module('cartographer.map', [])

_ = require 'underscore'
$ = require 'jquery'

module.exports.directive 'crtMap', $DI (crtLog, $window, $timeout, crtLocation, crtConfig, leafletData) ->
  return {
    restrict: 'A'
    replace: true
    require: 'crtMap'
    template: require './map.tpl.html'
    scope:
      location       : '=?' # location
      zoom           : '=?' # number
      fixed          : '=?' # boolean
      scrollWheel    : '=?' # boolean
      mapTilesId     : '=?mapTiles' # or('terrain', 'satellite')
      mapPaths       : '=?' # objectOf(string, path)
      attribution    : '=?' # arrayOf(string)
      onMapClick     : '=?' # location -> void
      onMarkerClick  : '=?' # location or(markerIdString, null) -> void
      onMarkerDrag   : '=?' # location or(markerIdString, null) -> void
      onPathClick    : '=?' # location or(markerIdString, null) -> void
      onBoundsChange : '=?' # location location -> void
    bindToController: true
    controllerAs: 'crtMap'
    link: ($scope, element, attrs, controller) ->
      crtMap = controller

      # crtLog.debug('crtMap.link')

      # angular-leaflet-directive broadcasts events from maps,
      # so we have to work out which map an event was from.
      #
      # This behaviour is marked as requiring rework:
      # https://github.com/tombatossals/angular-leaflet-directive/issues/265
      crtMap.leafletEventIsFromThisMap = (leafletData) ->
        target = leafletData.leafletEvent.originalEvent.target
        ans    = $.contains(element.get(0), target)
        # crtLog.debug('crtMap.leafletEventIsFromThisMap', leafletData, target, element, ans)
        ans

      return
    controller: $DI ($scope, $interval, crtString) ->
      crtMap = this

      # crtLog.debug('crtMap.location')

      crtMap.location       ?= crtLocation.london()
      crtMap.zoom           ?= crtConfig.map.defaultZoom
      crtMap.fixed          ?= false
      crtMap.scrollWheel    ?= true
      crtMap.mapTilesId     ?= crtConfig.map.defaultTiles
      crtMap.mapPaths       ?= {}

      # Location/zoom ---------------------------

      # Leaflet combines the center-point and zoom level into one object:
      updateLocation = ->
        crtMap.locationAndZoom =
          lng          : crtLocation.lng(crtMap.location)
          lat          : crtLocation.lat(crtMap.location)
          zoom         : crtMap.zoom
        return

      # When the map moves, update the location and zoom being used by the directive:
      locationUpdate = ->
        # crtLog.debug('crtMap.locationUpdate')
        if crtMap.locationAndZoom?
          if crtMap.locationAndZoom.lng? && crtMap.locationAndZoom.lat?
            crtMap.location = crtLocation.createPoint(
              crtMap.locationAndZoom.lng
              crtMap.locationAndZoom.lat
            )
          if crtMap.locationAndZoom.zoom?
            crtMap.zoom = crtMap.locationAndZoom.zoom
        return

      $scope.$watch('crtMap.location.coordinates[0]', updateLocation)
      $scope.$watch('crtMap.location.coordinates[1]', updateLocation)
      $scope.$watch('crtMap.zoom',                    updateLocation)
      $scope.$watch('crtMap.locationAndZoom.lng',     locationUpdate)
      $scope.$watch('crtMap.locationAndZoom.lat',     locationUpdate)
      $scope.$watch('crtMap.locationAndZoom.zoom',    locationUpdate)
      updateLocation()

      # Attribution -----------------------------

      updateAttribution = (newAttribution, oldAttribution) ->
        leafletMap().then (leafletMap) ->
          for attrib in (oldAttribution ? [])
            leafletMap.attributionControl.removeAttribution(attrib)
          for attrib in (newAttribution ? [])
            leafletMap.attributionControl.addAttribution(attrib)
          return
        return

      $scope.$watch('crtMap.attribution', updateAttribution)

      # Bounds / change events ------------------

      crtMap.bounds =
        northEast: undefined
        southWest: undefined

      crtMap.onBoundsChange ?= (->)

      $scope.$watch 'crtMap.bounds', (bounds) ->
        if bounds && bounds.northEast && bounds.southWest
          ne = crtLocation.createPoint(bounds.northEast.lng, bounds.northEast.lat)
          sw = crtLocation.createPoint(bounds.southWest.lng, bounds.southWest.lat)
          crtMap.onBoundsChange(ne, sw)
        return

      # Click events ----------------------------

      crtMap.mapMarkers    ?= {}
      crtMap.mapPaths      ?= {}
      crtMap.onMapClick    ?= (->)
      crtMap.onMarkerClick ?= (->)
      crtMap.onMarkerDrag  ?= (->)
      crtMap.onPathClick   ?= (->)

      # If the user double clicks, leaflet sends
      # two 'click' events and a 'dblclick' event.
      # We use $timeout to listen for 'dblclick' and cancel 'click'
      # so we only call the correct callback once.
      clickTimer = null
      cancelClickTimer = ->
        $timeout.cancel(clickTimer)
        return
      whenSingleClick = (func) ->
        cancelClickTimer()
        clickTimer = $timeout(func, crtConfig.map.doubleClickDelay)
        return

      $scope.$on 'leafletDirectiveMap.click', (scopeData, leafletData) ->
        crtLog.debug('leafletDirectiveMap.click', { scopeData, leafletData })
        if crtMap.leafletEventIsFromThisMap(leafletData)
          whenSingleClick ->
            # crtLog.debug('crtMap.$on(click)', scopeData, leafletData)
            evt = leafletData.leafletEvent
            evt.originalEvent.stopPropagation()
            evt.originalEvent.preventDefault()
            loc = crtLocation.createPoint(evt.latlng.lng, evt.latlng.lat)
            crtMap.onMapClick(loc)
            return
        return

      $scope.$on 'leafletDirectiveMap.dblclick', (scopeData, leafletData) ->
        crtLog.debug('leafletDirectiveMap.dblclick', { scopeData, leafletData })
        if crtMap.leafletEventIsFromThisMap(leafletData)
          cancelClickTimer()
          # crtLog.debug('crtMap.$on(dblclick)', scopeData, leafletData)
          return

      $scope.$on 'leafletDirectiveMarker.click', (scopeData, leafletData) ->
        crtLog.debug('leafletDirectiveMarker.click', { scopeData, leafletData })
        if crtMap.leafletEventIsFromThisMap(leafletData)
          whenSingleClick ->
            evt = leafletData.leafletEvent
            evt.originalEvent.stopPropagation()
            evt.originalEvent.preventDefault()
            loc = crtLocation.createPoint(evt.latlng.lng, evt.latlng.lat)
            crtMap.onMarkerClick(loc, leafletData.markerName)
        return

      $scope.$on 'leafletDirectiveMarker.dragend', (scopeData, leafletData) ->
        crtLog.debug('leafletDirectiveMarker.dragend', { scopeData, leafletData })
        if crtMap.leafletEventIsFromThisMap(leafletData)
          $timeout ->
            evt    = leafletData.leafletEvent
            latlng = evt.target.getLatLng()
            loc    = crtLocation.createPoint(latlng.lng, latlng.lat)
            crtMap.onMarkerDrag(loc, leafletData.markerName)
            return
        return

      _onPathClick = (scopeData, leafletData) ->
        crtLog.debug('leafletDirectivePath.click', { scopeData, leafletData })
        if crtMap.leafletEventIsFromThisMap(leafletData)
          whenSingleClick ->
            evt = leafletData.leafletEvent
            evt.originalEvent.stopPropagation()
            evt.originalEvent.preventDefault()
            loc = crtLocation.createPoint(evt.latlng.lng, evt.latlng.lat)
            crtMap.onPathClick(loc, leafletData.pathName)
        return

      # There seems to be a bug in Angular Leaflet Directive
      # that sometimes swallows "click" events for paths but not "mousedown" events:
      # https://github.com/tombatossals/angular-leaflet-directive/issues/1124
      $scope.$on('leafletDirectivePath.click', _onPathClick)
      $scope.$on('leafletDirectivePath.mousedown', _onPathClick)

      # Map options -----------------------------

      createTiles = (id, mapid) ->
        name          : id
        type          : 'xyz'
        url           : "https://api.mapbox.com/styles/v1/{mapid}/tiles/{z}/{x}/{y}?access_token={apikey}"
        options       :
          mapid       : mapid
          apikey      : crtConfig.map.mapbox.accessToken
          attribution : '<a href="http://www.mapbox.com/about/maps/" target="_blank">Terms &amp; Feedback</a>'
          tileSize    : 512
          zoomOffset  : -1

      terrainTiles    = createTiles('terrain', crtConfig.map.mapbox.tiles.terrain)
      satelliteTiles  = createTiles('satellite', crtConfig.map.mapbox.tiles.satellite)

      crtMap.mapTiles = terrainTiles

      # -> promiseOf(leaflet)
      leafletMap = ->
        leafletData.getMap("leaflet-map#{$scope.$id}")

      $scope.$watch 'crtMap.mapTilesId', (mapTilesId) ->
        crtMap.mapTiles = if mapTilesId == 'satellite' then satelliteTiles else crtMap.mapTiles = terrainTiles
        return

      # Resize detection ------------------------

      _invalidateSize = ->
        $scope.$apply ->
          leafletMap().then (map) ->
            map.invalidateSize(false)
            return
          return
        return

      $scope.$on 'navbar:toggle', ->
        $timeout(_invalidateSize, 50)
        return

      $window.requestAnimationFrame(_invalidateSize)

      return
  }
